import { useState } from "react";
import { CalendarBlank, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

function toDate(iso) {
  if (!iso) return undefined;
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? undefined : d;
}

function toIso(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function display(iso) {
  const d = toDate(iso);
  if (!d) return "";
  return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}/${d.getFullYear()}`;
}

// Styled calendar date picker (replaces native browser date inputs).
// value: ISO yyyy-mm-dd string or "". onChange receives the ISO string ("" when cleared).
export function DatePicker({ value, onChange, placeholder = "Pick a date", required, disabled, className = "", testId }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          data-testid={testId}
          className={`w-full justify-start rounded-sm border-[#E4E4E7] px-3 font-normal ${value ? "text-[#09090B]" : "text-[#6D6D70]"} ${className}`}
        >
          <CalendarBlank size={16} className="mr-2 shrink-0 text-[#032852]" />
          <span className="truncate">{value ? display(value) : placeholder}</span>
          {value && !required && (
            <span
              role="button"
              tabIndex={0}
              aria-label="Clear date"
              className="ml-auto rounded-sm p-0.5 text-[#6D6D70] hover:text-[#EF4444]"
              data-testid={testId ? `${testId}-clear` : undefined}
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); onChange(""); } }}
            >
              <X size={13} />
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto rounded-sm p-0" align="start">
        <Calendar
          mode="single"
          selected={toDate(value)}
          defaultMonth={toDate(value)}
          onSelect={(d) => { onChange(d ? toIso(d) : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
